export const SocialStepEnum = {
  SHARE_IT: 0,
  SHARE_SELECTION: 1
}
